import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TrainingProjectsStores } from '../stores';
import { STORE_TRAINING_PROJECTS } from '../stores/constants';
import { TrainingProjectsPage } from '../components';

const TrainingProjectsScreen: React.FC<TrainingProjectsStores> = ({ trainingProjectsStore }) => {
    if (!trainingProjectsStore) {
        return null;
    }

    return <TrainingProjectsPage store={trainingProjectsStore} />;
};

export default inject(STORE_TRAINING_PROJECTS)(observer(TrainingProjectsScreen));
